// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bulk-overclaim-leave-page-popup .confirmation-popup {
  display: flex;
  gap: 2rem;
}
.bulk-overclaim-leave-page-popup .confirmation-popup .primary {
  white-space: unset;
}
.bulk-overclaim-leave-page-popup .confirmation-popup h3 {
  font-size: 3.6rem;
  margin-bottom: 0;
}
.bulk-overclaim-leave-page-popup .confirmation-popup h4 {
  font-size: 2.8rem;
}`, "",{"version":3,"sources":["webpack://./src/kit/components/Popups/ConfirmationPopup/BulkActionLeavePageConfirmationPopup/index.scss"],"names":[],"mappings":"AACE;EACE,aAAA;EACA,SAAA;AAAJ;AAEI;EACE,kBAAA;AAAN;AAGI;EACE,iBAAA;EACA,gBAAA;AADN;AAII;EACE,iBAAA;AAFN","sourcesContent":[".bulk-overclaim-leave-page-popup {\n  .confirmation-popup {\n    display: flex;\n    gap: 2rem;\n\n    .primary {\n      white-space: unset;\n    }\n\n    h3 {\n      font-size: 3.6rem;\n      margin-bottom: 0;\n    }\n\n    h4 {\n      font-size: 2.8rem;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
